import {css} from 'emotion'
import { Colors } from '../core';

export const QuantityStyle = css({
  alignItems: 'center',
  position: 'relative',
  '.qty-less, .qty-more': {
    width: 25,
    height: 25,
    position: 'absolute',
    top: '50%',
    cursor: 'pointer',
    transform: 'translateY(-50%)',
    zIndex: 4,
    '&:after':{
      content:"''",
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: 12,
      height: '1px',
      background: Colors.grey,
      transform: 'translate(-50%, -50%)', 
    }
  },
  '.qty-less': {
    left: 0,
  },
  '.qty-more': {
    right: 0,
    '&:before': {
      content:"''",
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: 12,
      height: '1px',
      background: Colors.grey,
      transform: 'translate(-50%, -50%) rotate(-90deg)', 
      transformOrigin: 'center', 
    }
  },
})


// WEBPACK FOOTER //
// ./src/styles/components/quantity.js